"use strict";

define('rs/error/error.manager',['vertebrae', 'e3-modal', 'rs/error/error.controller'], function (Vertebrae, E3Modal, ErrorSectionController) {
  var ErrorManager = Vertebrae.Object.extend({
    properties: ['ErrorSection', 'ShowingModal', 'ErrorMessageQueue'],
    initialize: function initialize() {
      this.setErrorMessageQueue([]);
    },
    show: function show(errorMessage) {
      this.addMessageToQueue(errorMessage);
      return this.showModal();
    },
    isShowing: function isShowing() {
      return this.getShowingModal();
    },
    showModal: function showModal() {
      if (!this._currentDeferred) {
        var section = ErrorSectionController.create('Error'),
          modal = E3Modal.Controller.create(section);
        modal.getView().$el.addClass('error-modal');
        modal.on('show', function () {
          modal.getView().$el.find('.modal-footer > .btn[data-dismiss]').attr({
            id: 'errorModalCloseButton'
          });
        });
        this.setErrorSection(section);
        modal.on('show', this.modalDidShow.proxy(this));
        modal.on('hidden', this.modalDidHide.proxy(this));
        this._currentDeferred = modal.show();
      }
      return this._currentDeferred;
    },
    addMessageToQueue: function addMessageToQueue(errorMessage) {
      if (this.isShowing()) {
        this.getErrorSection().addMessage(errorMessage);
      } else {
        this.getErrorMessageQueue().push(errorMessage);
      }
    },
    modalDidShow: function modalDidShow() {
      var messages = this.getErrorMessageQueue();
      errorSection = this.getErrorSection();
      while (messages.length) {
        errorSection.addMessage(messages.pop());
      }
      this.setShowingModal(true);
    },
    modalDidHide: function modalDidHide() {
      this._currentDeferred = null;
      this.setShowingModal(false);
      this.setErrorSection(undefined);
    }
  }, {
    get: function get() {
      return this._singleton = this._singleton || new ErrorManager();
    },
    show: function show(errorMessage) {
      return this.get().show(errorMessage);
    },
    isShowing: function isShowing() {
      this.get().isShowing();
    }
  });
  window.RSError = ErrorManager;
  return ErrorManager;
});

